<template>
  <form-field
    :label="label"
    :validation-errors="validationErrors"
    :label-for="forId"
    :help-text="helpText"
    :class="{'inline-datepicker': isInline}"
  >
    <b-datepicker
      :id="forId"
      v-bind="$attrs"
      icon="calendar-today"
      size="is-small"
      :inline="isInline"
      :class="[classAttr, {'text-center': isInline}]"
      expanded

      :value="date"
      :min-date="minDate"
      :max-date="maxDate"
      :range="isRange"

      locale="en-US"
      @input="handleInput"
    >
      <button-link
        v-if="hasClearButton"
        label="Clear"
        color="is-danger"
        @click="handleInput(null)"
      />
    </b-datepicker>
  </form-field>
</template>

<script>
import dates from "../../services/dates";

export default {
  name: "FormFieldDatePicker",
  props: {
    value: {
      type: [Array, String, Number, Boolean, Date]
    },
    label: {
      type: String,
    },
    minDate: {
      type: Date
    },
    maxDate: {
      type: Date
    },
    validationErrors: [String, Array, undefined],
    isInline: {
      type: Boolean,
      default: false
    },
    isRange: {
      type: Boolean,
      default: false
    },
    hasClearButton: {
      type: Boolean,
      default: false
    },
    classAttr: {
      type: String,
      default: ''
    },
    helpText: {
      type: String
    }
  },
  data() {
    return {
      forId: this.$utils.generateClientId(),
    }
  },
  computed: {
    date() {
      /**
       * When dates are given to frontend and not in a timestamp then we get a Not a Date error
       * This checks for "/" in the date and use JS Date to convert to a timestamp which is our standard
       * The reason for this is custom fields can't be Carbon instances via backend
       * due to being inside a JSON object
       */
      if ((typeof this.value === 'string' || this.value instanceof String) && this.value.includes('/')) {
        return dates.getJSDate(new Date(this.value).toISOString())
      }

      if (this.value && !this.isRange) {
        if (this.value instanceof Date) return this.value;

        return dates.getJSDate(this.value);
      }

      if (this.isRange && this.value[0] && this.value[1]) {
        return [
          (this.value[0] instanceof Date) ? this.value[0] : dates.getJSDate(this.value[0]),
          (this.value[1] instanceof Date) ? this.value[1] : dates.getJSDate(this.value[0])
        ];
      }

      return null;
    }
  },
  methods: {
    handleInput(date) {
      /*
        Don't convert to ISO string if the calendar used is a range type
        It won't allow us to convert the date (buefy datepicker restriction/limitation)
        Do the conversion to ISO string on the parent component
       */
      if (!this.isRange && typeof date != 'object') {
        date = date.toISOString();
      }

      this.$emit('input', date);
      this.$emit('change', date);
      this.$emit('selected', date);
    }
  }
}
</script>

<style lang="scss" scoped>
.inline-datepicker {
  max-width: 310px;
  margin: 0 auto 1rem;
}
</style>
